var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5007 7.16667C10.6597 7.16667 9.16732 5.67428 9.16732 3.83333C9.16732 1.99238 10.6597 0.5 12.5007 0.5C14.3416 0.5 15.834 1.99238 15.834 3.83333C15.834 5.67428 14.3416 7.16667 12.5007 7.16667ZM12.5007 5.5C11.5802 5.5 10.834 4.75381 10.834 3.83333C10.834 2.91286 11.5802 2.16667 12.5007 2.16667C13.4211 2.16667 14.1673 2.91286 14.1673 3.83333C14.1673 4.75381 13.4211 5.5 12.5007 5.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 9.66667C8.70708 9.66667 8.33398 10.0398 8.33398 10.5V15.5H6.66732V10.5C6.66732 9.11929 7.78661 8 9.16732 8H15.834C17.2147 8 18.334 9.11929 18.334 10.5V15.5H16.6673V10.5C16.6673 10.0398 16.2942 9.66667 15.834 9.66667H9.16732Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 7.16667H5.83398V8.83333H0.833984V7.16667Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 10.5H0.833984V12.1667H5.00065V10.5Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 3.83333H6.66732V5.5H0.833984V3.83333Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClients);
export default __webpack_public_path__ + "static/media/menu-clients.e1001e697e5f104e6024825df4455a79.svg";
export { ForwardRef as ReactComponent };